module.exports = __webpack_public_path__ + "static/andy_prasad-27b9205fd2d83c434efb160f4bdf84db.jpg";